import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import userManager from '../../helpers/UserManager'

const LoginRedirect = () => {
  const history = useNavigate()
  useEffect(() => {
    const getUser = async () => {
      const user = await userManager.getUserWhenLogin()

      if (user.state && user.state != '/login') {
        history(user.state)
      } else {
        history('/boatlist')
      }
    }
    getUser().catch(() => {
      userManager.signIn()
    })
  }, [])
  return <></>
}

export default LoginRedirect
